import React from 'react'
import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'
import { INSIGHT_WIDGET_PRINTABLE_CLASS } from 'src/atoms/report-insight'

type InsightCardTransparentProps = {
  id?: string
  children?: React.ReactNode
}

export const InsightCardTransparentWrapper = styled.div`
  padding: ${Shapes.spacing[4]}px;
`
export const InsightCardTransparent: React.FC<InsightCardTransparentProps> = (props) => {
  const { id, children } = props

  return (
    <InsightCardTransparentWrapper id={id} className={INSIGHT_WIDGET_PRINTABLE_CLASS}>
      {children}
    </InsightCardTransparentWrapper>
  )
}
